module.exports = __webpack_public_path__ + "static/media/image-03-full.146fef82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/image-03-full.jpg
// module id = 352
// module chunks = 0